import queryApi from '@/api/query';

const SET_QUERIES = 'SET_QUERIES';
const ADD_QUERY = 'ADD_QUERY';
const DELETE_QUERY = 'DELETE_QUERY';
const UPDATE_QUERY = 'UPDATE_QUERY';

const state = {
  queries: [],
  queriesTimetamp: 0
};

const getters = {
  getQueries: state => {
    return state.queries;
  }
};

const mutations = {
  [SET_QUERIES] (state, queries) {
    state.queries = queries;
    state.queriesTimetamp = new Date().getTime();
  },
  [ADD_QUERY] (state, query) {
    state.queries.push(query);
  },
  [UPDATE_QUERY] (state, query) {
    const index = state.queries.map(e => e.id).indexOf(query.id);
    state.queries.splice(index, 1, query);
  },
  [DELETE_QUERY] (state, id) {
    const index = state.queries.map(e => e.id).indexOf(id);
    state.queries.splice(index, 1);
  }
};

const actions = {
  retrieveQueries ({ state, commit }, { context, tags }) {
    if (new Date().getTime() - state.queriesTimetamp < 60000) {
      return;
    }

    queryApi.getQueries(context, tags).then(data => {
      commit(SET_QUERIES, data);
    });
  },
  createQuery ({ commit }, { context, query }) {
    return new Promise((resolve, reject) => {
      queryApi.createQuery(context, query)
        .then(data => {
          commit(ADD_QUERY, data);
          resolve();
        }, error => {
          reject(error);
        });
    });
  },
  updateQuery ({ commit }, { context, query }) {
    return new Promise((resolve, reject) => {
      queryApi.updateQuery(context, query)
        .then(data => {
          commit(UPDATE_QUERY, data);
          resolve();
        }, error => {
          reject(error);
        });
    });
  },
  deleteQuery ({ commit }, { context, id }) {
    return new Promise((resolve, reject) => {
      queryApi.deleteQuery(context, id)
        .then(() => {
          commit(DELETE_QUERY, id);
          resolve();
        }, error => {
          reject(error);
        });
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/query/index.js